const Container = {
  baseStyle: {
    maxW: '100vw',
  },
  variants: {
    centered: {
      maxW: {base: '100%', lg: '1200px'},
    },
    withShadow: {
      p: {base: 5, md: 10},
      borderRadius: '20px',
      bg: 'white',
      boxShadow: '0 4px 50px rgba(0,0,0, 0.1)',
    },
    flow: {
      p: 5,
      borderRadius: '10px',
      bg: 'white',
      boxShadow: '0 4px 50px rgba(0,0,0, 0.1)',
    },
  },
}
export default Container
